import { useState } from 'react';
import type { NotificationType, NotificationTarget } from '../types';

interface SearchFiltersProps {
  onSearch: (filters: {
    title: string;
    type: NotificationType | '';
    target: NotificationTarget | '';
    createTimeStart: string;
    createTimeEnd: string;
    notificationTimeStart: string;
    notificationTimeEnd: string;
  }) => void;
}

export default function SearchFilters({ onSearch }: SearchFiltersProps) {
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [filters, setFilters] = useState({
    title: '',
    type: '' as NotificationType | '',
    target: '' as NotificationTarget | '',
    createTimeStart: '',
    createTimeEnd: '',
    notificationTimeStart: '',
    notificationTimeEnd: ''
  });

  const handleSearch = () => {
    onSearch(filters);
  };

  const handleReset = () => {
    const resetFilters = {
      title: '',
      type: '' as NotificationType | '',
      target: '' as NotificationTarget | '',
      createTimeStart: '',
      createTimeEnd: '',
      notificationTimeStart: '',
      notificationTimeEnd: ''
    };
    setFilters(resetFilters);
    onSearch(resetFilters);
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-5">
      <div className="flex items-center gap-4 mb-4">
        <div className="flex-1">
          <input
            type="text"
            placeholder="搜索通知标题"
            value={filters.title}
            onChange={(e) => setFilters({ ...filters, title: e.target.value })}
            className="w-full px-4 py-2 border border-gray-200 rounded-lg text-sm"
          />
        </div>
        <button
          onClick={() => setShowAdvanced(!showAdvanced)}
          className="px-4 py-2 text-sm text-teal-600 hover:bg-teal-50 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className={`ri-filter-3-line mr-2`}></i>
          {showAdvanced ? '收起筛选' : '高级筛选'}
        </button>
        <button
          onClick={handleSearch}
          className="px-6 py-2 bg-teal-500 text-white text-sm rounded-lg hover:bg-teal-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-search-line mr-2"></i>
          搜索
        </button>
      </div>

      {showAdvanced && (
        <div className="pt-4 border-t border-gray-200 space-y-4">
          <div className="grid grid-cols-4 gap-4">
            <div>
              <label className="block text-sm text-gray-700 mb-2">通知类型</label>
              <select
                value={filters.type}
                onChange={(e) => setFilters({ ...filters, type: e.target.value as NotificationType | '' })}
                className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm cursor-pointer"
              >
                <option value="">全部</option>
                <option value="platform">平台通知</option>
                <option value="activity">活动通知</option>
              </select>
            </div>

            <div>
              <label className="block text-sm text-gray-700 mb-2">通知对象</label>
              <select
                value={filters.target}
                onChange={(e) => setFilters({ ...filters, target: e.target.value as NotificationTarget | '' })}
                className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm cursor-pointer"
              >
                <option value="">全部</option>
                <option value="all-users">全体用户</option>
                <option value="all-schools">全体学校（管理员）</option>
                <option value="all-enterprises">全体企业（管理员）</option>
              </select>
            </div>

            <div>
              <label className="block text-sm text-gray-700 mb-2">创建时间开始</label>
              <input
                type="datetime-local"
                value={filters.createTimeStart}
                onChange={(e) => setFilters({ ...filters, createTimeStart: e.target.value })}
                className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm cursor-pointer"
              />
            </div>

            <div>
              <label className="block text-sm text-gray-700 mb-2">创建时间结束</label>
              <input
                type="datetime-local"
                value={filters.createTimeEnd}
                onChange={(e) => setFilters({ ...filters, createTimeEnd: e.target.value })}
                className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm cursor-pointer"
              />
            </div>

            <div>
              <label className="block text-sm text-gray-700 mb-2">通知时间开始</label>
              <input
                type="datetime-local"
                value={filters.notificationTimeStart}
                onChange={(e) => setFilters({ ...filters, notificationTimeStart: e.target.value })}
                className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm cursor-pointer"
              />
            </div>

            <div>
              <label className="block text-sm text-gray-700 mb-2">通知时间结束</label>
              <input
                type="datetime-local"
                value={filters.notificationTimeEnd}
                onChange={(e) => setFilters({ ...filters, notificationTimeEnd: e.target.value })}
                className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm cursor-pointer"
              />
            </div>
          </div>

          <div className="flex items-center justify-end gap-3">
            <button
              onClick={handleReset}
              className="px-4 py-2 text-sm text-gray-600 hover:bg-gray-50 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              重置
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
